const expressPreparationForPL300MicrosoftPowerBIDataAnalyst = [
  {
    type: "heading",
    text: "PL-300 Introduction",
  },
  {
    type: "paragraph",
    text: "The Microsoft Power BI Data Analyst certification is mainly targeted to those candidates who want to build their career in Microsoft Power BI. The Microsoft-certified Power BI Data Analyst Associate exam verifies that the candidate possesses the fundamental knowledge and proven skills in the field of Data Analysis.",
  },
  {
    type: "paragraph",
    text: "Getting an official Microsoft certification is an important step for anyone who works with Microsoft Power BI. While Power BI is featured in the more basic PL-900 Microsoft Power Platform Fundamentals exam, the standard exam for users of the software is DA-100: Analysing Data with Microsoft Power BI. DA-100 replaced the 70-778: Analysing and Visualizing Data with Microsoft Power BI exam. Now, only a year on, DA-100 has itself been replaced with a new exam – PL-300: Power BI Data Analyst. While DA-100 granted the 'Data Analyst Associate' certification, takers of the PL-300 exam will gain the 'Power BI Data Analyst Associate' certification.",
  },
  {
    type: "heading",
    text: "Who can apply for the DA-100 exam?",
  },
  {
    type: "paragraph",
    text: "This certification is suitable for those who are:",
  },
  {
    type: "list",
    items: [
      "Business Intelligence Professionals",
      "Data analysts",
      "IT Managers",
      "Professionals who use Power BI",
      "Data Scientists",
      "Professionals Managing Data for Decision-making",
      "Individuals who want to gain a clear understanding of the Microsoft Power BI Tool",
    ],
  },
  {
    type: "heading",
    text: "Skills Measured",
  },
  {
    type: "list",
    items: [
      "Prepare the data (15–20%)",
      "Model the data (30–35%)",
      "Visualize and analyse the data (25–30%)",
      "Deploy and maintain assets (20–25%)",
    ],
  },
  {
    type: "heading",
    text: "My experience!",
  },
  {
    type: "paragraph",
    text: "Since I had previous work experience with Microsoft Power BI, the exam wasn't tough for me. It took me around 21 days to prepare for the exam, as I could study only at the weekends. I prepared primarily from Microsoft Learn and Udemy courses. The exam questions were generally on the easy to moderate side, but the DAX queries and case studies were a bit tough. It took me a few minutes to get familiar with the case study questions and the purpose of various tabs present there. The course mentioned below will give an overview of the type and difficulty level of the questions.",
  },
  {
    type: "heading",
    text: "Days of preparation",
  },
  {
    type: "paragraph",
    text: "The preparation timeline can vary between 2 weeks to 4 weeks, depending on your familiarity with Microsoft Power BI. You should go through the learning paths at least once and then focus more on the difficult areas. Practicing hands-on will play a crucial role in passing the exam. Taking notes while going through the learning paths will help you later.",
  },
  {
    type: "heading",
    text: "Learning Path",
  },
  {
    type: "paragraph",
    text: "I followed the Microsoft learning path for preparation, which gave me an idea on how to navigate through the topics.",
  },
  {
    type: "paragraph",
    text: "Learning Path – <a href='https://arch-center.azureedge.net/Learning/Credentials/Learning-path-for-Microsoft-Certified--Power-BI-Data-Analyst-Associate.pdf' target='_blank' style='color: #E31837; text-decoration: none;'>https://query.prod.cms.rt.microsoft.com/cms/api/am/binary/RWvnnf</a>",
  },
  {
    type: "heading",
    text: "Study Material",
  },
  {
    type: "paragraph",
    text: "I followed the below courses for preparation:",
  },
  {
    type: "list",
    items: [
      "Udemy – <a href='https://www.udemy.com/course/power-bi-da-100-certification-fast-track/' target='_blank' style='color: #E31837; text-decoration: none;'>Power BI PL-300 Certification Fast Track</a>",
      "Udemy – <a href='https://www.udemy.com/course/pl-300-practice-tests-microsoft-power-bi-data-analyst/' target='_blank' style='color: #E31837; text-decoration: none;'>PL-300 Practice Tests (Microsoft Power BI Data Analyst)</a>",
    ],
  },
  {
    type: "paragraph",
    text: "These courses helped me understand the type of questions and the way to approach the questions. Since this blog is focused on experienced professionals, these courses give insights into the structure & difficulty level of the exam.",
  },
  {
    type: "heading",
    text: "About the Author",
  },
  {
    type: "paragraph",
    text: "Tanvi Chourasia is a Microsoft Certified Power BI Data Analyst, working as Senior Business Intelligence Analyst at Comsense Technologies Private Limited. She has over 6.5 years of experience in Business Intelligence Tools, Business Analytics focusing on implementing data analytics using Power BI and QlikView.",
  },
];

export default expressPreparationForPL300MicrosoftPowerBIDataAnalyst;
